export default __webpack_public_path__ + "images/bus-icon.a93368d.svg";